var map = {
	"./404.svg": 44297,
	"./FAQ.svg": 66085,
	"./PWChange.svg": 85916,
	"./Vector.svg": 12042,
	"./api_management.svg": 6581,
	"./arrow-down-black-base-dark.svg": 43878,
	"./arrow-down-black-base.svg": 51789,
	"./arrow-down-black.svg": 57209,
	"./arrow-down-blue.svg": 73444,
	"./arrow-down-white.svg": 42447,
	"./arrow-right.svg": 73935,
	"./arrow-up-blue.svg": 40801,
	"./asset-dashboard.svg": 49618,
	"./asset-main.svg": 87357,
	"./asset-membership.svg": 45126,
	"./asset-open-order.svg": 39105,
	"./asset-order-history.svg": 53977,
	"./asset-referral.svg": 81685,
	"./asset-reward.svg": 42883,
	"./asset-trade-history.svg": 73583,
	"./bitcoin.svg": 48483,
	"./callendar-range-dark.svg": 33048,
	"./callendar-range-light.svg": 72952,
	"./cancel-gi.svg": 89290,
	"./change.svg": 34571,
	"./check-gi.svg": 28262,
	"./chip.svg": 24345,
	"./code.svg": 17720,
	"./coin/binance-ico.svg": 16435,
	"./coin/bitcoin-ico.svg": 15199,
	"./coin/btc.svg": 81184,
	"./coin/cindicator-ico.svg": 46405,
	"./coin/eth.svg": 2972,
	"./coin/iconom-ico.svg": 37564,
	"./coin/omisego_ico.svg": 84204,
	"./coin/ripple_ico.svg": 36535,
	"./coin/tetherUS-ico.svg": 64935,
	"./coin/tetherum-ico.svg": 35753,
	"./coin/usd.svg": 15925,
	"./coin/usdt.svg": 62563,
	"./collapse_18_18.svg": 13294,
	"./confirmRemove-dark.svg": 79158,
	"./confirmRemove.svg": 17789,
	"./confirmed-withdrawal-dark.svg": 93239,
	"./confirmed-withdrawal.svg": 45902,
	"./cons_pin.svg": 85056,
	"./convert.svg": 78692,
	"./copper-icon.svg": 16066,
	"./copy-dark.svg": 38629,
	"./copy.svg": 94296,
	"./dashboard.svg": 76357,
	"./date-tim-order-dark.svg": 54066,
	"./date-time-home-dark.svg": 81130,
	"./date-time-order.svg": 32628,
	"./date-time-yellow.svg": 32412,
	"./date-time.svg": 68915,
	"./device.svg": 36781,
	"./device_1.svg": 46817,
	"./diamon.svg": 54351,
	"./earm.svg": 73890,
	"./excel_export_16_16.svg": 81357,
	"./expand.svg": 28047,
	"./expand_18_18.svg": 11931,
	"./eyes-close.svg": 62086,
	"./face.svg": 70520,
	"./facebook.svg": 95015,
	"./favorite_blue.svg": 17846,
	"./favorite_white.svg": 31941,
	"./flag_en.svg": 19805,
	"./flag_ko.svg": 32714,
	"./flag_vi.svg": 18383,
	"./fly.svg": 6402,
	"./future.svg": 74070,
	"./global-lang.svg": 93055,
	"./gold-icon.svg": 15457,
	"./google-plus.svg": 1735,
	"./group.svg": 80104,
	"./hamberger_icon-dark.svg": 61097,
	"./hamberger_icon.svg": 99412,
	"./hight.svg": 71949,
	"./icon-chat.svg": 61271,
	"./icon-close-toast.svg": 8361,
	"./icon-close.svg": 97523,
	"./icon-copy.svg": 14374,
	"./icon-error-input.svg": 29842,
	"./icon-error.svg": 32233,
	"./icon-export-history.svg": 33996,
	"./icon-export.svg": 8435,
	"./icon-face-dark.svg": 21039,
	"./icon-face.svg": 10102,
	"./icon-fb.svg": 99413,
	"./icon-futures-spot.svg": 92384,
	"./icon-get-link.svg": 45040,
	"./icon-get-reward.svg": 33541,
	"./icon-in-referral-dark.svg": 65247,
	"./icon-in-referral.svg": 41286,
	"./icon-invite-friend.svg": 83563,
	"./icon-linkedin.svg": 63523,
	"./icon-no-data.svg": 17973,
	"./icon-open-history-black-dark.svg": 57397,
	"./icon-open-history-black.svg": 91656,
	"./icon-open-history-green.svg": 86616,
	"./icon-order-success.svg": 75113,
	"./icon-plus.svg": 43813,
	"./icon-spot-order.svg": 28454,
	"./icon-success.svg": 16634,
	"./icon-trade-history-black-dark.svg": 893,
	"./icon-trade-history-black.svg": 1504,
	"./icon-trade-history-green.svg": 54016,
	"./icon-twitter-referral-dark.svg": 42073,
	"./icon-twitter-referral.svg": 72804,
	"./icon-twitter.svg": 55706,
	"./icon-verified.svg": 81005,
	"./icon-warning.svg": 22239,
	"./identification.svg": 67045,
	"./info-gi-mobile.svg": 87275,
	"./info-gi.svg": 46888,
	"./infor-dark.svg": 47080,
	"./infor-light.svg": 82984,
	"./infor.svg": 78747,
	"./insta.svg": 13836,
	"./inta.svg": 14019,
	"./invalid-modal-light.svg": 1415,
	"./invalid-modal.svg": 65436,
	"./like.svg": 84030,
	"./link.svg": 85727,
	"./lock.svg": 79962,
	"./log-out.svg": 40612,
	"./logo_coin_m_dark.svg": 40725,
	"./logo_coin_m_light.svg": 95347,
	"./logo_usd_m_dark.svg": 74018,
	"./logo_usd_m_light.svg": 77242,
	"./logout.svg": 6069,
	"./money-data.svg": 93494,
	"./moon-light.svg": 85207,
	"./moon.svg": 15180,
	"./mountain.svg": 68634,
	"./note-warning.svg": 46304,
	"./notice.svg": 87063,
	"./overview_wallet.svg": 54682,
	"./phone.svg": 99753,
	"./question-circle.svg": 23056,
	"./referral.svg": 3388,
	"./resend-email.svg": 98613,
	"./resetMail.svg": 8577,
	"./reward_center.svg": 41554,
	"./safety.svg": 18681,
	"./saving.svg": 61445,
	"./security.svg": 21901,
	"./send-mail-success-dark.svg": 39614,
	"./send-mail-success.svg": 60085,
	"./setting.svg": 71541,
	"./sliver-icon.svg": 60456,
	"./snap.svg": 61355,
	"./social/icon-facebook.svg": 56243,
	"./social/icon-google-plus.svg": 42739,
	"./social/icon-instagram3.svg": 50592,
	"./social/icon-linkedin.svg": 59781,
	"./social/icon-reddit3.svg": 8342,
	"./social/icon-telegram.svg": 66058,
	"./social/icon-twitter.svg": 42396,
	"./social/icon-wechat.svg": 48589,
	"./social/icon-weibo.svg": 78737,
	"./social/icon-whatsapp3.svg": 34708,
	"./social/icon-youtube.svg": 29730,
	"./social/icon-youtube3.svg": 52733,
	"./spot.svg": 83411,
	"./staking.svg": 7202,
	"./star_blue.svg": 41938,
	"./star_gray.svg": 99535,
	"./success.svg": 93076,
	"./successCheck-dark.svg": 15489,
	"./successCheck.svg": 96252,
	"./sun-light.svg": 90700,
	"./sun.svg": 56447,
	"./teth.svg": 22606,
	"./trace2.svg": 75920,
	"./traced.svg": 27918,
	"./transaction_history.svg": 32168,
	"./tweet.svg": 94194,
	"./tweeter.svg": 54267,
	"./usd.svg": 63145,
	"./usdt.svg": 78503,
	"./user_21_21.svg": 99402,
	"./user_black.svg": 83638,
	"./user_blue.svg": 13621,
	"./warning-gi.svg": 62454,
	"./warning-mail-invalid-dark.svg": 12710,
	"./warning-mail-invalid.svg": 37485,
	"./www.svg": 21560,
	"./youtube.svg": 27174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64241;